import { render } from "./BaseView.vue?vue&type=template&id=dc1ca500"
import script from "./BaseView.vue?vue&type=script&lang=js"
export * from "./BaseView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/BaseView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc1ca500"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc1ca500', __exports__)) {
    api.reload('dc1ca500', __exports__)
  }
  
  module.hot.accept("./BaseView.vue?vue&type=template&id=dc1ca500", () => {
    api.rerender('dc1ca500', render)
  })

}


export default __exports__